import React, { useState, useEffect } from 'react';
import { Menu, X, Leaf, Bike, Instagram, Facebook, Twitter } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { EVENT_CONFIG } from '@/lib/index';
import { IMAGES } from '@/assets/images';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Evento',
    href: '#evento'
  }, {
    name: 'Recorridos',
    href: '#recorridos'
  }, {
    name: 'Reserva',
    href: '#reserva'
  }, {
    name: 'Sostenibilidad',
    href: '#sostenibilidad'
  }, {
    name: 'Impacto Local',
    href: '#impacto-local'
  }, {
    name: 'Galería',
    href: '#galeria'
  }];
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  return <div className="min-h-screen flex flex-col selection:bg-accent/30 selection:text-accent-foreground">
      {/* Fixed Header */}
      <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300 h-20 border-b', isScrolled ? 'bg-background/90 backdrop-blur-md border-border py-2' : 'bg-transparent border-transparent py-4')}>
        <div className="container mx-auto px-4 h-full flex items-center justify-between">
          {/* Logo */}
          <a href="#hero" className="flex items-center gap-3 group">
            <div className="relative w-12 h-12 overflow-hidden rounded-full border border-border bg-white">
              <img src={IMAGES.LOGO_RESERVA} alt={EVENT_CONFIG.name} className="w-full h-full object-contain p-1 transition-transform duration-500 group-hover:scale-110" />
            </div>
            <div className="hidden md:block">
              <h1 className="text-lg font-bold leading-none tracking-tighter uppercase">
                Ibiza Bike <span className="text-accent">Epic</span>
              </h1>
              <p className="text-[10px] uppercase tracking-[0.2em] font-mono text-muted-foreground">
                {EVENT_CONFIG.tagline}
              </p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium uppercase tracking-widest hover:text-accent transition-colors">
                {link.name}
              </a>)}
            <Button asChild variant="default" className="bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground transition-all px-6 rounded-full">
              <a href="#inscripcion">Inscribirse</a>
            </Button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden p-2 text-foreground hover:bg-muted rounded-md transition-colors" onClick={toggleMobileMenu} aria-label="Menu Principal">
            {isMobileMenuOpen ? <X size={24} className="text-accent" /> : <Menu size={24} className="text-accent" />}
          </button>
        </div>
      </header>

      {/* Mobile Navigation Overlay */}
      <AnimatePresence>
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-40 bg-background pt-24 px-6 lg:hidden">
            <nav className="flex flex-col gap-6 items-center">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-bold uppercase tracking-tighter hover:text-accent transition-colors">
                  {link.name}
                </a>)}
              <Button asChild className="w-full py-6 text-lg rounded-full mt-4 bg-accent text-accent-foreground" onClick={() => setIsMobileMenuOpen(false)}>
                <a href="#inscripcion">Inscribirse Ahora</a>
              </Button>
              <div className="flex gap-6 mt-12 text-muted-foreground">
                <Instagram size={24} className="text-accent hover:text-accent/80 cursor-pointer" />
                <Facebook size={24} className="text-accent hover:text-accent/80 cursor-pointer" />
                <Twitter size={24} className="text-accent hover:text-accent/80 cursor-pointer" />
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>

      {/* Main Content */}
      <main className="flex-grow">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-primary text-primary-foreground py-16">
        <div className="container mx-auto px-4">Ibiza Bike EpicEl evento de ciclismo más equilibrado del Mediterráneo. Carretera y senderos en un entorno único.Sobre el EventoMapas y RutasPlan SostenibleRegistro ExternoEvento Sostenible© 2026 Ibiza Bike Epic. Todos los derechos reservados.Aviso LegalPrivacidadCookies</div>
      </footer>
    </div>;
}